import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=3acaa394&scoped=true&"
import script from "./Textarea.vue?vue&type=script&lang=js&"
export * from "./Textarea.vue?vue&type=script&lang=js&"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=3acaa394&prod&lang=scss&scoped=true&"
import style1 from "./Textarea.vue?vue&type=style&index=1&id=3acaa394&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acaa394",
  null
  
)

export default component.exports